import { ReactNode, useEffect, createContext, useContext, useState } from "react"
import { Configuration as ApiConfiguration, AuthenticationApi, AuthenticationTypeDTO, ConfigurationParameters, OAuth2DTO } from "../data";
import { AuthenticatedTemplate, OAuth2Provider, UnauthenticatedTemplate, useOAuth2Context } from "./OAuth2Context";
import UnauthenticatedContent from "../UnauthenticatedContent";


export const OAuthTemplate = ({ children }: { children: ReactNode }) => <>{children}</>

interface AuthenticationContextType {
    authenticationType: AuthenticationTypeDTO;
}

const AuthenticationContext = createContext<AuthenticationContextType>(undefined);

export const useAuthenticationContext = () => {
    const context = useContext(AuthenticationContext);
    if (!context)
        throw new Error("useAuthenticationContext deve essere usato all'interno di <AuthenticationProvider>");

    return context;
}

export const AuthenticationProvider = ({ children }: { children: ReactNode }) => {
    const [authenticationType, setAuthenticationType] = useState<AuthenticationTypeDTO>(null);

    useEffect(() => {
        (async function () {
            var authenticationType = JSON.parse(sessionStorage.getItem("hyper.timesheet.authenticationType")) as AuthenticationTypeDTO;

            if (!authenticationType) {
                const configParams: ConfigurationParameters = {
                    basePath: process.env.REACT_APP_API_URL
                };
                var api = new AuthenticationApi(new ApiConfiguration(configParams));
                authenticationType = await api.getAuthenticationType();
                sessionStorage.setItem("hyper.timesheet.authenticationType", JSON.stringify(authenticationType));
            }

            setAuthenticationType(authenticationType);
        })();
    }, []);


    return (
        <AuthenticationContext.Provider value={{ authenticationType }}>
            {authenticationType?.type === "OAuth2" && (
                <OAuth2Provider oAuth2Config={authenticationType.oAuth2} >
                    <AuthenticatedTemplate>
                        {children}
                    </AuthenticatedTemplate>
                    <UnauthenticatedTemplate>
                        <UnauthenticatedContent />
                    </UnauthenticatedTemplate>
                </OAuth2Provider>
            )}
        </AuthenticationContext.Provider>
    )
}